import {
    SAVE_NOTES_REQUEST,
    SAVE_NOTES_SUCCESS,
    SAVE_NOTES_ERROR
  } from "./SaveNotesTypes";
  
  const initialState = {
    loading: false,
    isSubmitted: false,
    successMessage: "",
    errorMessage: "",
    saveNotes: []
  };
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case SAVE_NOTES_REQUEST:
        return {
          ...state,
          isSubmitted: true,
          loading: true
        };
      case SAVE_NOTES_SUCCESS:
        // do something
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          saveNotes: action.payload,
          successMessage: "Notes created successfully!",
          errorMessage: ""
        };
      case SAVE_NOTES_ERROR:
        return {
          ...state,
          loading: false,
          isSubmitted: false,
          saveNotes: [],
          errorMessage: action.payload
        };
      default:
        return state;
    }
  };
  